import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelRadio as _vModelRadio, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "glores-B-login" }
const _hoisted_6 = {
  class: "login-type-selector",
  style: {"margin-bottom":"15px","text-align":"center"}
}
const _hoisted_7 = { style: {"margin-right":"20px"} }
const _hoisted_8 = { class: "glores-B-login-form" }
const _hoisted_9 = { class: "login-input-box" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { for: "input_id" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = ["required"]
const _hoisted_14 = { class: "login-check-box" }
const _hoisted_15 = {
  key: 0,
  class: "social-login-buttons",
  style: {"margin-top":"20px","text-align":"center","padding-top":"20px","border-top":"1px solid #eee"}
}
const _hoisted_16 = {
  key: 1,
  class: "login-btn-box"
}
const _hoisted_17 = {
  key: 1,
  class: "glores-B-login"
}
const _hoisted_18 = {
  class: "glores-B-login-msg",
  style: {"padding":"20px","text-align":"center","font-size":"1.1em"}
}
const _hoisted_19 = {
  class: "glores-B-login-btns",
  style: {"text-align":"center","padding-bottom":"20px"}
}

import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const {
  loginType,
  form,
  loading,
  isLoggedIn,
  loggedInUserId,
  signInWithGoogle,
  signInWithKakao,
  handleSubmit,
  handleLogout,
  showForgotPasswordModal,
  forgotPasswordUid,
  forgotPasswordLoading,
  openForgotPasswordModal,
  closeForgotPasswordModal,
  handleForgotPasswordRequest,
} = useAuth();

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "mypage",
      subtitle: "mypage",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_Loading, null, null, 512), [
        [_vShow, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[26] || (_cache[26] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("mypage"),
          _createElementVNode("span")
        ], -1)),
        (!_unref(isLoggedIn))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("form", {
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleSubmit) && _unref(handleSubmit)(...args)), ["prevent"]))
              }, [
                _cache[23] || (_cache[23] = _createStaticVNode("<input type=\"hidden\" name=\"re_url\" value=\"\"><input type=\"hidden\" name=\"this_domain\"><input type=\"hidden\" name=\"post_action\"><input type=\"hidden\" name=\"mode\"><input type=\"hidden\" name=\"popup\" value=\"\"><input type=\"hidden\" name=\"form_sess_id\" value=\"716vsn2hkvktapfcokmmb69lg7\"><input type=\"hidden\" name=\"form_id_name\" value=\"\">", 7)),
                _createElementVNode("div", _hoisted_5, [
                  _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "glores-B-login-title" }, [
                    _createElementVNode("span", null, "회원 로그인")
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "login_type_radio",
                        value: "user",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loginType) ? (loginType).value = $event : null))
                      }, null, 512), [
                        [_vModelRadio, _unref(loginType)]
                      ]),
                      _cache[14] || (_cache[14] = _createTextVNode(" 일반 회원 "))
                    ]),
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "login_type_radio",
                        value: "organization",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(loginType) ? (loginType).value = $event : null))
                      }, null, 512), [
                        [_vModelRadio, _unref(loginType)]
                      ]),
                      _cache[15] || (_cache[15] = _createTextVNode(" 기관 회원 "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("ul", null, [
                        (_unref(loginType) === 'organization')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "input_org_id" }, "기관 아이디", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "org_id",
                                id: "input_org_id",
                                placeholder: "기관 아이디",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).orgId) = $event))
                              }, null, 512), [
                                [_vModelText, _unref(form).orgId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(loginType) === "organization"
                          ? "사용자 아이디"
                          : "아이디"), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "id",
                            id: "input_id",
                            placeholder: 
                          _unref(loginType) === 'organization'
                            ? '사용자 아이디'
                            : '아이디'
                        ,
                            required: "",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).uid) = $event))
                          }, null, 8, _hoisted_12), [
                            [_vModelText, _unref(form).uid]
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { for: "input_pw" }, "비밀번호", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            name: "pwd",
                            id: "input_pw",
                            maxlength: "16",
                            placeholder: "비밀번호",
                            required: _ctx.required,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).password) = $event))
                          }, null, 8, _hoisted_13), [
                            [_vModelText, _unref(form).password]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "id_save",
                          id: "id_save",
                          value: "1",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).idSave) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _unref(form).idSave]
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("label", { for: "id_save" }, "아이디 저장", -1))
                      ])
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "login-btn-submit" }, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn-login",
                        style: {"background":"#c0c0c0"}
                      }, " 로그인 ")
                    ], -1)),
                    (_unref(loginType) === 'user')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[19] || (_cache[19] = _createElementVNode("p", { style: {"margin-bottom":"15px","font-size":"0.9em","color":"#666"} }, " 또는 소셜 계정으로 간편하게 로그인하세요. ", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(signInWithGoogle) && _unref(signInWithGoogle)(...args))),
                            class: "btn-social-google",
                            style: {"background-color":"#db4437","color":"white","border":"none","padding":"10px 15px","border-radius":"4px","cursor":"pointer","margin-right":"10px","font-size":"0.9em"}
                          }, " 구글 로그인 "),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(signInWithKakao) && _unref(signInWithKakao)(...args))),
                            class: "btn-social-kakao",
                            style: {"background-color":"#fee500","color":"#3c1e1e","border":"none","padding":"10px 15px","border-radius":"4px","cursor":"pointer","font-size":"0.9em"}
                          }, " 카카오 로그인 ")
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(loginType) === 'user')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            to: `${_unref(USER_ROUTES).Join.Path}`
                          }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode("회원가입")
                            ])),
                            _: 1
                          }, 8, ["to"]),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openForgotPasswordModal) && _unref(openForgotPasswordModal)(...args)), ["prevent"]))
                            }, "비밀번호 찾기")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 32)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "glores-B-login-title" }, [
                _createElementVNode("span", null, "로그인 정보")
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(loggedInUserId)), 1),
                  _cache[24] || (_cache[24] = _createTextVNode("님으로 로그인 되어있습니다. "))
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(handleLogout) && _unref(handleLogout)(...args))),
                  class: "btn-logout",
                  style: {"padding":"10px 20px","background-color":"#555","color":"white","border":"none","border-radius":"4px","cursor":"pointer"}
                }, " 로그아웃 ")
              ])
            ]))
      ]),
      _createVNode(_component_n_modal, {
        show: _unref(showForgotPasswordModal),
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_isRef(showForgotPasswordModal) ? (showForgotPasswordModal).value = $event : null)),
        preset: "card",
        style: {"width":"500px"},
        title: "비밀번호 찾기/재설정",
        "mask-closable": false,
        closable: true,
        onAfterLeave: _cache[13] || (_cache[13] = ($event: any) => (forgotPasswordUid.value = ''))
      }, {
        default: _withCtx(() => [
          _cache[29] || (_cache[29] = _createElementVNode("p", { style: {"margin-bottom":"15px"} }, " 아이디를 입력해주세요. 가입 시 등록된 이메일 주소로 임시 비밀번호가 전송됩니다. 로그인 후 반드시 비밀번호를 변경해주세요. ", -1)),
          _createVNode(_component_n_form, {
            onSubmit: _withModifiers(_unref(handleForgotPasswordRequest), ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_form_item, {
                label: "아이디",
                path: "forgotPasswordUid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _unref(forgotPasswordUid),
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_isRef(forgotPasswordUid) ? (forgotPasswordUid).value = $event : null)),
                    placeholder: "아이디 입력",
                    onKeydown: _withKeys(_withModifiers(_unref(handleForgotPasswordRequest), ["prevent"]), ["enter"])
                  }, null, 8, ["value", "onKeydown"])
                ]),
                _: 1
              }),
              _createVNode(_component_n_space, { justify: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    onClick: _unref(closeForgotPasswordModal),
                    disabled: _unref(forgotPasswordLoading)
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode("취소")
                    ])),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _createVNode(_component_n_button, {
                    type: "primary",
                    "attr-type": "submit",
                    loading: _unref(forgotPasswordLoading)
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode(" 임시 비밀번호 발송 ")
                    ])),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}
}

})